import { getFlowDurationInMillis } from './convert.js';
import { FlowDurationSchema } from './duration.js';
/**
 * A {@link FlowDurationSchema} that additionally rejects durations longer than `max`.
 * Bound violations are reported against `pathName`, which also names the field in the message.
 */
export function FlowDurationSchemaWithMax(args) {
    const { pathName, max } = args;
    const maxMillis = getFlowDurationInMillis(max.value, max.units);
    return FlowDurationSchema.refine((duration) => {
        const millis = getFlowDurationInMillis(duration.value, duration.units);
        return millis <= maxMillis;
    }, { message: `Max ${pathName} is ${String(max.value)} ${max.units}`, path: [pathName] });
}
//# sourceMappingURL=withMax.js.map